import { useHistory } from 'react-router';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { DOCUMENT_KINDS } from '../../../../DocumentCapture.helpers';
import { ExampleDocuments } from '../../../ExampleDocuments/ExampleDocuments';
import { EXAMPLE_DOCUMENTS } from '../../../ExampleDocuments/ExampleDocuments.helpers';
import { ReactComponent as CaptureLicense } from '../assets/CaptureLicense.svg';
import { IncodeFooter } from '../components/IncodeFooter';
import { IncodeHeader } from '../components/IncodeHeader';
import { INCODE_ANALYTICS } from '../IncodeAnalytics';

import LocalTexts from './Incode.texts.json';

import styles from './IncodeCaptureLicense.module.scss';

const LocalT = new MDText(LocalTexts.license);

const CTA = LocalT.translate('cta') as string;

export const IncodeCaptureLicenseTutorial = () => {
  const history = useHistory();

  return (
    <>
      <IncodeHeader
        instructions={LocalT.translate('instructions', {
          more: <span className={styles.exampleDocLink}>
            <ExampleDocuments
              {
                ...EXAMPLE_DOCUMENTS[
                  DOCUMENT_KINDS.DRIVING_LICENCE as keyof typeof EXAMPLE_DOCUMENTS
                ] as Record<string, unknown>
              }
              actionLink={LocalT.translate('learnMore') as string}
              documentTitle={LocalT.translate('modal.title') as string}
              modalDescription={LocalT.translate('modal.description') as string}
              modalStyle="bottomSheet"
            />
          </span>,
        })}
        title={LocalT.translate('title')}
      />
      <figure className={styles.illustration}>
        <CaptureLicense />
      </figure>
      <IncodeFooter>
        <Button
          fullWidth
          label={CTA}
          onClick={() => {
            INCODE_ANALYTICS.INCODE_CTA_CLICK({
              button_label: CTA,
              name: 'incode_driving_license_tips_clicked',
            });

            history.replace(
              {
                pathname: globalThis.location.pathname,
                state: { incode: true },
              },
            );
          }}
        />
      </IncodeFooter>
    </>
  );
};
